import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import './Dns.scss'
import { DnsComponent } from '../../components/Dns-component/DnsComponent'
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


export const Dns = (props: { darkMode?: boolean }) => {
  const { operatorId } = useParams();
  const { t } = useTranslation();

  const [box1Data, setBox1Data] = useState<number>(0)
  const [box2Data, setBox2Data] = useState<number>(0)
  const [box3Data, setBox3Data] = useState<number>(0)
  const [box4Data, setBox4Data] = useState<number>(0)

  useEffect(() => {
    fetchApi()
  }, [])

  async function fetchApi() {
    const response = await axios.get(`/v2/op/master-operator/${operatorId}/global-counts`)

    setBox1Data(response.data.data[0].past24HourDns || 0)
    setBox2Data(response.data.data[0].uniqueFqdns || 0)
    setBox3Data(response.data.data[0].blockedDnsRequests || 0)
    setBox4Data(response.data.data[0].uniqueBlockedFqdns || 0)
  }

  return (

    <section>
      <DnsComponent 
        box1Title={t('activity.kpi.dnsRequestsToday')}
        box1Quantity={box1Data}
        box1Icon="/icons/CPEs-managed.svg"

        box2Title={t('activity.kpi.uniqueUrlsVisitedToday')}
        box2Quantity={box2Data}
        box2Icon="/icons/Device-managed.svg"

        box3Title={t('activity.kpi.dnsRequestsBlockedToday')}
        box3Quantity={box3Data}
        box3Icon="/icons/Mobile-managed.svg"    

        box4Title={t('activity.kpi.uniqueUrlsBlockedToday')}
        box4Quantity={box4Data}
        box4Icon="/icons/Threats-managed.svg"

        type='all'
        darkMode={props.darkMode}
      />
    </section>
  );
};
